var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c(_vm.layoutComponent,{tag:"component"},[_c('v-main',[_c('router-view',{key:_vm.$route.fullPath}),_c('notifications'),_c('error-message')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }